<script>
/**
* @描述
* 将物品增加或减少的方法
* @使用方法
<gHandleNumber :num.sync="backNum"></gHandleNumber>
* @param
* num  数量
* plus 点击增加按钮事件
* minus 点击减少按钮事件
* @LastEditTime: 最后更新时间
* 2021-10-21
* @Author: andy凌云
*/
</script>
<template>
  <div>
    <div class="add-r">
      <div @click="minusNum">
        <g-img
          :src="require('@/assets/images/reduce_icon.png')"
          :size="50"
        ></g-img>
      </div>
      <div class="c">
        {{sNum}}
      </div>
      <div @click="plusNum">
        <g-img
          :src="require('@/assets/images/add_icon_active.png')"
          :size="50"
        ></g-img>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GHandleNumber",
  props: {
    num: {
      type: Number,
      default: 1,
    },
    plus: {
      type: [Function, String],
      default: '',
    },
    minus: {
      type: [Function, String],
      default: '',
    }

  },
  data() {
    return {
      sNum: this.num
    };
  },
  watch: {
    num(val) {
      this.sNum = val
    }
  },
  components: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    minusNum() {
      if (typeof this.minus === 'function') {
        this.minus()
      } else {
        if (this.sNum === 1) {
          return this.$toast('数量最少为1')
        }
        this.sNum--
        this.$emit('update:num', this.sNum)
      }
    },
    plusNum() {
      if (typeof this.plus === 'function') {
        this.plus()
      } else {
        this.sNum++
        this.$emit('update:num', this.sNum)
      }
    },

  }
};
</script>
<style scoped lang='scss'>
.add-r {
  width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* height: 20px; */
}
</style>
